export const disclaimer = `
	<h1>Règles d'utilisation</h1>
	<p>Cette application a pour but de faciliter le recensement des idées d'action au sein d'Extinction Rebellion France.</p>
	<p>Elle permet notamment:<ul>
		<li>de proposer une idée d'action, précise et détaillée</li>
		<li>de manifester son enthousiasme pour les idées d'action proposées ("likes")</li>
		<li>de commenter une idée d'action afin de l'améliorer</li>
		<li>de partager un compte rendu ("feedback") d'une action réalisée, afin de conserver et de retracer les succès et les difficultées rencontrées.</li>
	</ul></p>
	<h4>Certaines précautions de confidentialité et de discrétion doivent être <strong>impérativement</strong> respectées :</h4>
	<ul>
		<li>Ne jamais mentionner le lieu ni la date d'une action en cours de préparation</li>
		<li>Ne jamais indiquer de liste détaillée des participants d'une action en cours de préparation</li>
	</ul>
	<br />
	<p>Vous trouverez plus de détails concernant la préparation des actions au sein d'XR France dans le <a href="https://rdv.extinctionrebellion.fr/index.php/s/Ta7nmziFcfdsf7W"><strong>MANUEL POUR PERMETTRE L’AUTO-ORGANISATION D’ACTION DE DESOBEISSANCE CIVILE NON-VIOLENTE</strong></a>.</p>
`;